<template lang="pug">
shListData(title="Colores" resolver="colors" keyData="color" component="shColor")
</template>

<script>
import shListData from '@/components/global/ListData'

export default {
  name: 'Colors',

  components: { shListData }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/color/Colors.vue